import React, { useMemo } from 'react';
import { useGetCities } from '@area-restrita/api-client/endpoints/address/address.gen';

import Combobox, { ComboboxOption } from '@/components/Combobox';

interface IProps {
  stateId?: number;
  value?: ComboboxOption;
  onChange?: (option?: ComboboxOption) => void;
  className?: string;
}

const CitySelector: React.FC<IProps> = ({ stateId, onChange, ...props }) => {
  const { data, isLoading } = useGetCities(
    { stateId },
    { query: { enabled: !!stateId } },
  );

  const options = useMemo(
    () =>
      data?.map<ComboboxOption>((uf) => ({
        value: uf.id,
        label: uf.name,
      })) ?? [],
    [data],
  );

  return (
    <Combobox
      options={options}
      emptyText="Nenhuma cidade encontrada"
      placeholder="Selecione a cidade..."
      searchPlaceholder="Pesquise a cidade..."
      // showSearch
      isLoading={isLoading}
      onChangeValue={onChange}
      {...props}
    />
  );
};

export default CitySelector;
